<template>
    <v-container id="school-level" fluid tag="section">
        <filter-form :filterForm="filterForm" />
        <div class="text-sm-right mb-4" v-if="checkAuthorization('school-level_create')">
            <v-btn
                    class="primary mx-0"
                    @click="addNewSchoolLevel"
            >
                <v-icon>mdi-plus</v-icon>Thêm Mới
            </v-btn>
        </div>
        <v-card>
            <school-level-table :schoolLevelList="schoolLevelList" />

            <v-row class="mt-4">
                <v-col cols="12" sm="6" />
                <v-col cols="12" sm="6">
                <v-pagination
                    v-if="totalItem > limit"
                    v-model="currentPage"
                    class="justify-sm-end"
                    :length="getTotalItem(totalItem, limit)"
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                />
                </v-col>
            </v-row>
        </v-card>

        <school-level-form />
    </v-container>
</template>

<script>
import SchoolLevelTable from "./components/SchoolLevelTable"
import FilterForm from "./components/FilterForm"
import SchoolLevelForm from "./components/SchoolLevelForm"
import RepositoryFactory from "../../repositories/RepositoryFactory"
const SchoolLevelRepository = RepositoryFactory.get('school_level')

export default {
    components: {
        SchoolLevelTable,
        FilterForm,
        SchoolLevelForm
    },
    data() {
        return {
            totalItem: 0,
            limit: 10,
            currentPage: 1,
            filterForm: {},
            schoolLevelList: []
        }
    },

    watch: {
        currentPage: {
            deep: true,
            handler() {
                this.getListSchoolLevel()
            }
        }
    },

    created() {
        this.getListSchoolLevel()

        Bus.$on('search-school-level', (filterForm) => {
            this.filterForm = FilterForm
            this.currentPage = 1
            this.getListSchoolLevel()
        })

        Bus.$on('delete-school-level', (id) => {
            this.deleteSchoolLevel(id)
        })

        Bus.$on('update-school-level', () => {
            this.getListSchoolLevel()
        })

        Bus.$on('create-school-level', () => {
            this.currentPage = 1
            this.getListSchoolLevel()
        })
    },

    methods: {
        async getListSchoolLevel() {
            const loading = this.$loading.show()
            const params = {
                page: this.currentPage - 1,
                limit: this.limit,
                code: this.filterForm.code,
                keyword: this.filterForm.keyword
            }
            const res = await SchoolLevelRepository.list(params)
            if (res.success) {
                this.schoolLevelList = _.get(res, 'data', [])
                this.totalItem = _.get(res, 'totalItem', 0) 
            } else {
                this.schoolLevelList = []
                this.totalItem = 0
            }
            loading.hide()
        },

        addNewSchoolLevel() {
            Bus.$emit('school-level-show-form', {})
        },

        async deleteSchoolLevel(id) {
            const res = await SchoolLevelRepository.delete(id) 
            if (res.success) {
                this.getListSchoolLevel()
            } else {
                this.$swal({
                    title: 'Lỗi !',
                    text: _.get(res, 'message', '')
                })
            }
        }
    }
}
</script>

<style scoped>

</style>